import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCustomerCateringUserMutationVariables = Types.Exact<{
  payload: Types.CreateCustomerCateringUser;
}>;


export type CreateCustomerCateringUserMutation = { __typename?: 'Mutation', createCustomerCateringUser: string };


export const CreateCustomerCateringUserDocument = gql`
    mutation CreateCustomerCateringUser($payload: CreateCustomerCateringUser!) {
  createCustomerCateringUser(payload: $payload)
}
    `;
export type CreateCustomerCateringUserMutationFn = Apollo.MutationFunction<CreateCustomerCateringUserMutation, CreateCustomerCateringUserMutationVariables>;

/**
 * __useCreateCustomerCateringUserMutation__
 *
 * To run a mutation, you first call `useCreateCustomerCateringUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerCateringUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerCateringUserMutation, { data, loading, error }] = useCreateCustomerCateringUserMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateCustomerCateringUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerCateringUserMutation, CreateCustomerCateringUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerCateringUserMutation, CreateCustomerCateringUserMutationVariables>(CreateCustomerCateringUserDocument, options);
      }
export type CreateCustomerCateringUserMutationHookResult = ReturnType<typeof useCreateCustomerCateringUserMutation>;
export type CreateCustomerCateringUserMutationResult = Apollo.MutationResult<CreateCustomerCateringUserMutation>;
export type CreateCustomerCateringUserMutationOptions = Apollo.BaseMutationOptions<CreateCustomerCateringUserMutation, CreateCustomerCateringUserMutationVariables>;